import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
//import Card from '@material-ui/core/Card';
//import CardContent from '@material-ui/core/CardContent';
//import Typography from '@material-ui/core/Typography';


const styles = theme => ({
  card: {
    margin: 2,
    boxShadow: 'none',
  },
  cardHeader: {
    //backgroundColor:'#10526a',
    color: '#fff',
  },
  statValue: {
    //fontSize: '1.2em',
    marginRight: '2px',
    fontFamily: 'Flanders Art Sans!important',
  },
  cardContent: {
    fontFamily: 'Flanders Art Sans!important',
  },
  label: {
    color: '#105269!important',
    fontFamily: 'Flanders Art Sans!important',
  },
  statContainer: {
    textAlign: 'left',
    //fontWeight: 500,
    lineHeight: '1.4em',
    paddingTop:'12px',
    [theme.breakpoints.up('lg')]: {
      lineHeight: '1em',
      paddingTop:'10px',
    },
  },
  imageBlock: {
    display: 'block',
    margin: '0 auto',
    textIndent: '-9999px',
    //background: 'url("/images/electricity_production.svg")',
    //width: '40px',
    //height: '40px',
    //backgroundSize: '40px 40px',
    backgroundSize: 'contain!important',
    backgroundRepeat: 'no-repeat!important',
    backgroundPosition: 'center center!important',
    width: '80%',
    height: 0,
    minWidth: '40px',
    maxWidth: '40px',
    minHeight: '40px',
    maxHeight: '40px',
  },
  energysum: {
    background: 'url("/images/vea_indicator/groene_stroom.svg")',
  },
  //residentialfacilities: {
  //  background: 'url("/images/vea_indicator/solar_residential.svg")',
  //},
  //industrialfacilities: {
  //  background: 'url("/images/vea_indicator/solar_industrial.svg")',
  //},
  energyaspercentageofdemand: {
    background: 'url("/images/vea_indicator/aandeel.svg")',
  },
  energyaspercentageofdemandpeak: {
    background: 'url("/images/vea_indicator/productiepiek.svg")',
  },
  //electricalvehicles: {
  //  background: 'url("/images/vea_indicator/electric_car.svg")',
  //},
  nbhouseholdcovered: {
    background: 'url("/images/vea_indicator/woning.svg")',
  },
  co2avoided: {
    background: 'url("/images/vea_indicator/CO2.svg")',
  },
  clearLeft: {
    clear: 'left',
  }
});

function Indicator(props) {
  const { classes } = props;

  let selectedImageSelector = props.name.replace(/_/g, "")

  const digits=props.value>1000?0:1
  
  return (
    <Grid item container style={{padding:'8px'}}>
      <Grid item xs={props.name === 'residential_facilities' || props.name === 'industrial_facilities' ? 4 : 2}>
        <div className={classes.imageBlock + " " + classes[selectedImageSelector]}></div>
        {/*<img className={classes.statImage} src={image} alt={props.label}/>*/}
      </Grid>
      <Grid item xs={props.name === 'residential_facilities' || props.name === 'industrial_facilities' ? 8 : 10} className={classes.statContainer + ' darkbluegreen'}>
        <span className={classes.statValue}>{(props.value.toLocaleString('nl-BE', { minimumFractionDigits: digits, maximumFractionDigits: digits })) + (props.unit ? (props.unit === '%' ? props.unit : '') : '')}</span>
        <span className={(props.name === 'residential_facilities' || props.name === 'industrial_facilities' ? classes.clearLeft : '')}>{(props.unit ? (props.unit === '%' ? '' : (' ' + props.unit)) : '') + ' ' + props.label}</span>
      </Grid>
    </Grid>
  );
}

Indicator.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string,
  value: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(Indicator);